"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = 10000000; // eg. 10MB
